<!-- 用户功能 - 登陆弹窗 -->

<template>
  <transition name="fade">
    <div id="login-box">
      <div id="login" class="bgshade-box"></div>
      <div class="con-box">
        <!-- Login Information -->
        <form class="form-box" @keydown.enter="userLogin">
          <p class="title-row">
            <span class="login-tit">登录</span>
            <span class="login-close" @click="closePopup"></span>
          </p>
          <p class="info-row tips tipsTop" v-if="userTips.loginResTips">
            {{ userTips.loginResTips }}
          </p>
          <p class="info-row">
            <!-- start -->
            <!-- 解决谷歌浏览器选择保存密码后自动填充 -->
            <input type="text" class="input-text" style="display: none" />
            <!-- ie9下模拟placeholder -->
            <label
              for="loginUserID"
              v-if="placeholder.loginUserID"
              class="simulate-placeholder"
              @click="ie9hideInputID"
              >手机号&nbsp;/&nbsp;邮箱&nbsp;/&nbsp;IP360账号</label
            >
            <!-- end -->
            <input
              type="text"
              class="input-text"
              v-model="userVal.userIdVal"
              @blur="checkUser"
              ref="userID"
              placeholder="手机号 / 邮箱 / IP360账号"
              key="user-login"
              id="loginUserID"
              @focus="ie9hideInputID"
            />
          </p>
          <p class="info-row tips" v-if="userTips.userIdTips">
            {{ userTips.userIdTips }}
          </p>
          <p class="pwd-row info-row">
            <!-- start -->
            <!-- 解决谷歌浏览器选择保存密码后自动填充 -->
            <input type="password" class="input-text" style="display: none" />
            <!-- ie9下模拟placeholder -->
            <label
              for="loginUserPW"
              v-if="placeholder.loginUserPW"
              class="simulate-placeholder"
              @click="ie9hideInputPW"
              >密码</label
            >
            <!-- end -->
            <input
              type="password"
              class="input-text"
              v-model="userVal.userPwdVal"
              @blur="checkPwd"
              ref="userPwd"
              placeholder="密码"
              key="user-pwd"
              id="loginUserPW"
              @focus="ie9hideInputPW"
              autocomplete="false"
            />
            <img
              src="../../assets/user/hidepwd.png"
              v-if="hidepwd"
              @click="pwdIsShow"
            />
            <img
              src="../../assets/user/showpwd.png"
              v-if="showpwd"
              @click="pwdIsShow"
            />
          </p>
          <p class="info-row tips" v-if="userTips.userPwdTips">
            {{ userTips.userPwdTips }}
          </p>
          <p style="position: relative">
            <!-- start -->
            <!-- ie9下模拟placeholder -->
            <label
              for="loginUserSEC"
              v-if="placeholder.loginUserSEC"
              class="simulate-placeholder"
              @click="ie9hideInputSEC"
              >验证码</label
            >
            <!-- end -->
            <input
              type="text"
              class="input-text input-code"
              v-model="userVal.secVal"
              @blur="checkSec"
              placeholder="验证码"
              id="loginUserSEC"
              @focus="ie9hideInputSEC"
            />
            <img
              :src="vcodeUrl"
              class="input-text input-codebtn"
              @click="getVcode"
            />
          </p>
          <p class="info-row clearfix">
            <span class="tips" v-if="userTips.userSecTips">{{
              userTips.userSecTips
            }}</span>
            <span style="float: right">
              <a href="javascript:;" @click="reset">忘记密码？</a>
            </span>
          </p>
          <!-- <span><input type="checkbox" name="" class="auto-login" ref="isRemember" checked>记住密码</span> -->
          <p class="submit-row">
            <a @keydown.enter="userLogin" @click="userLogin" href="javascript:;"
              >登&nbsp;录</a
            >
          </p>
          <p class="no-userID">
            <a href="#" @click="goRegister">没有账号?&nbsp;立即注册</a>
          </p>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
//    import this.$axios from 'axios';

// 删除cookie
let delCookie = (name) => {
  setCookie(name, 1, -1);
};

//设置cookie
let setCookie = (name, value, day) => {
  var oDate = new Date();
  oDate.setDate(oDate.getDate() + day);
  document.cookie =
    name + "=" + JSON.stringify(value) + ";expires=" + oDate + ';path="/"';
};

//获取cookie
let getCookie = (name) => {
  let arr = document.cookie.split(";");
  for (var i = 0; i < arr.length; i++) {
    let arrName = arr[i].split("=");
    if (arrName[0] == name) {
      return arrName[1];
    }
  }
  return "";
};

export default {
  name: "register",
  data() {
    return {
      userVal: {
        userIdVal: "",
        userPwdVal: "",
        secVal: "",
      },
      checkRes: {
        userIDCheckRes: false,
        userPwdCheckRes: false,
        secCheckRes: false,
      },
      userTips: {
        userIdTips: "",
        userPwdTips: "",
        loginResTips: "",
        userSecTips: "",
      },
      hidepwd: true,
      showpwd: false,
      //          errorTimes:0,
      //          showsec: false,
      INPUTRULES: {
        email:
          /^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
        mobile:
          /^(((13[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(14[0-9]{1}))+\d{8})$/,
        password: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/,
        qrcode: /^[a-zA-Z0-9]{4}$/,
      },
      baseVcodeUrl: "",
      vcodeUrl: "",
      redirect: "",
      placeholder: {
        loginUserID: false,
        loginUserPW: false,
        loginUserSEC: false,
      },
      //公钥
      pubKey: "",
    };
  },
  mounted() {
    //读取本地用户信息
    // let str = getCookie('IP360');
    // if(str){
    //     let res = JSON.parse(getCookie('IP360'));
    //     //更新用户名
    //     this.userVal.userIdVal = res.userIdVal;
    //     this.userVal.userPwdVal = res.userPwdVal;
    // } else {
    //     this.userVal.userIdVal = '';
    //     this.userVal.userPwdVal = '';
    // }
    this.init();
    this.getVcode();

    //处理ie9下placeholder
    if (!this.$isPlaceholder()) {
      //当ie9不支持palceholder时  利用label模拟placeholder
      if (this.userVal.userIdVal == "") {
        this.placeholder.loginUserID = true;
      }
      if (this.userVal.userPwdVal == "") {
        this.placeholder.loginUserPW = true;
      }
      this.placeholder.loginUserSEC = true;
    }

    //获取本地错误次数
    //      this.errorTimes = localStorage.getItem("TruthsoerrTimes")||0;
    //      if (this.errorTimes>=5) {
    //        this.showsec = true;
    //      }
  },
  methods: {
    init() {
      this.baseVcodeUrl = this.GlobalConfig.vcodeUrl;
      this.vcodeUrl = this.GlobalConfig.vcodeUrl;
      this.getEncryptPubKey();
    },
    //获取公钥
    getEncryptPubKey() {
      this.$axios
        .request({
          url: "/webapi/user/getEncryptPubKey",
          method: "GET",
          params: {},
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.pubKey = res.data.datas.encryptPubKey;
          }
        });
    },
    /**
     * 通过公钥进行加密
     * data:要加密的数据
     */
    setEncrypt(data) {
      const jsRsa = new this.$jsEncrypt();
      //设置公钥
      jsRsa.setPublicKey(this.pubKey);
      //使用加密对象给数据加密
      let RsaData = jsRsa.encrypt(data);
      return RsaData;
    },
    //关闭弹窗
    closePopup() {
      this.$store.commit("hidePopWindow", "loginWin");
      //      this.$emit('closeLoginPopup')
    },
    reset() {
      this.$store.commit("hidePopWindow", "loginWin");
      this.$router.push("/reset");
    },
    //检测用户名
    checkUser() {
      if (this.userVal.userIdVal != "") {
        if (
          this.INPUTRULES.mobile.test(this.userVal.userIdVal) ||
          this.INPUTRULES.email.test(this.userVal.userIdVal)
        ) {
          this.checkRes.userIDCheckRes = true;
          this.userTips.userIdTips = "";
          this.$axios
            .request({
              url: "/webapi/user/checkAccount",
              method: "GET",
              params: {
                account: this.userVal.userIdVal,
              },
            })
            .then((response) => {
              let res = response.data;
              if (res.code == 3004) {
                this.userTips.userIdTips = res.message;
                this.checkRes.userIDCheckRes = false;
              }
            });
        } else {
          this.checkRes.userIDCheckRes = false;
          this.userTips.userIdTips = "用户名格式有误";
        }
      } else {
        //是空并且不支持palceholder(ie9)的情况下
        if (!this.$isPlaceholder()) {
          this.placeholder.loginUserID = true;
        }
      }
    },
    //检测密码
    checkPwd() {
      if (this.userVal.userPwdVal != "") {
        if (this.INPUTRULES.password.test(this.userVal.userPwdVal)) {
          this.userTips.userPwdTips = "";
          this.checkRes.userPwdCheckRes = true;
        } else {
          this.userTips.userPwdTips = "密码格式错误";
          this.checkRes.userPwdCheckRes = false;
        }
      } else {
        //是空并且不支持palceholder(ie9)的情况下
        if (!this.$isPlaceholder()) {
          this.placeholder.loginUserPW = true;
        }
      }
    },
    //检测验证码
    checkSec() {
      if (this.userVal.secVal) {
        if (this.INPUTRULES.qrcode.test(this.userVal.secVal)) {
          this.checkRes.secCheckRes = true;
          this.userTips.userSecTips = "";
        } else {
          this.checkRes.secCheckRes = false;
          this.userTips.userSecTips = "验证码格式错误";
        }
      } else {
        //是空并且不支持palceholder(ie9)的情况下
        if (!this.$isPlaceholder()) {
          this.placeholder.loginUserSEC = true;
        }
      }
    },
    //登录
    userLogin() {
      this.checkUser();
      this.checkPwd();
      this.checkSec();
      //              this.checkRes.secCheckRes = true;
      if (
        this.checkRes.userIDCheckRes &&
        this.checkRes.userPwdCheckRes &&
        this.checkRes.secCheckRes
      ) {
        this.$axios
          .request({
            url: "/webapi/user/login/loginSubmitV2",
            method: "get",
            params: {
              encryptAccount: this.setEncrypt(this.userVal.userIdVal),
              encryptPassword: this.setEncrypt(
                this.$md5(this.userVal.userPwdVal)
              ),
              vcode: this.userVal.secVal,
            },
          })
          .then((response) => {
            this.getVcode();
            // console.log('登录信息:',response);
            if (
              response.data.code == 200 &&
              response.data.datas.loginUser.lockStatus == 2
            ) {
              let user = response.data.datas.loginUser;
              user.timestamp = Date.now();
              user.token = response.data.datas.token;
              let Truthso = {
                user: user,
              };
              //缓存到本地
              localStorage.setItem("IP360", JSON.stringify(Truthso));
              this.$store.commit("login", response.data.datas.loginUser);
              // console.log( 'test:',response.data.datas.loginUser)
              this.$emit("loggedIn", response.data.datas.loginUser);
              // if(this.$refs.isRemember.checked) {
              //     setCookie('IP360',this.userVal,7);
              // } else {
              //     setCookie('IP360',this.userVal,-1)
              // }
              this.$store.commit("hidePopWindow", "loginWin");
              this.$store.dispatch("showMsgModal", {
                autoClose: true,
                info: "登录成功",
              });
              // console.log("#2111231321",Truthso)
              if (this.$store.state.redirect) {
                this.$router.push(this.$store.state.redirect);
                this.$store.state.redirect = "";
              } else if (
                this.$router.currentRoute.path.indexOf("results") != -1
              ) {
                this.$router.go(0);
              }
              this.redirect = "";
            } else if (
              response.data.code == 200 &&
              response.data.datas.loginUser.lockStatus == 1
            ) {
              this.userTips.loginResTips = "账户未激活";
            } else if (response.data.code == 3012) {
              this.userTips.loginResTips = response.data.message;
            } else {
              this.userTips.loginResTips = response.data.message;
            }
          });

        //                localStorage.removeItem("TruthsoerrTimes");
      }
      if (this.userVal.userIdVal == "") {
        this.userTips.userIdTips = "请输入用户名";
      }
      if (this.userVal.userPwdVal == "") {
        this.userTips.userPwdTips = "请输入密码";
      }
      if (this.userVal.secVal == "") {
        this.userTips.userSecTips = "请输入验证码";
      }
    },
    //密码显示与否
    pwdIsShow() {
      if (this.$refs.userPwd.type == "text") {
        this.$refs.userPwd.type = "password";
        this.hidepwd = true;
        this.showpwd = false;
      } else {
        this.$refs.userPwd.type = "text";
        this.hidepwd = false;
        this.showpwd = true;
      }
    },
    goRegister() {
      this.$store.commit("hidePopWindow", "loginWin");
      this.$store.commit("showPopWindow", "registerWin");
    },
    getVcode() {
      this.vcodeUrl = this.baseVcodeUrl + "?time=" + Date.now();
      //              e.target.src = '';
      //              e.target.src = 'http://59.110.44.147:9060/webapi/user/login/getCode?time=' + Date.now();
    },
    ie9hideInputID() {
      this.placeholder.loginUserID = false;
    },
    ie9hideInputPW() {
      this.placeholder.loginUserPW = false;
    },
    ie9hideInputSEC() {
      this.placeholder.loginUserSEC = false;
    },
  },
  watch: {
    $route(to, from) {
      //刷新参数放到这里里面去触发就可以刷新相同界面了
      let params = this.$queryUrlParams(to.fullPath);
      if (params.redirect) {
        this.redirect = params.redirect;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*  reset style */
p {
  margin: 0;
}
a {
  text-decoration: none;
  color: #000;
}
input,
button {
  outline: 0;
}
#login-box,
.bgshade-box {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
}
/* basis style */
.bgshade-box {
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 16px;
  filter: alpha(opacity=50);
  box-sizing: border-box;
}
.con-box {
  width: 408px;
  background: #fff;
  border-radius: 5px;
  /* border: 1px solid #Eb828c; */
  position: absolute;
  top: 16%;
  left: 50%;
  transform: translate(-204px, 0);
}
@media (min-height: 670px) {
  .con-box {
    top: 20%;
  }
}
/* form style */
.form-box {
  width: 364px;
  margin: 0 auto;
}
.form-box .title-row {
  height: 38px;
  margin-top: 19px;
  color: #b11828;
  font-weight: 700;
}
.form-box .login-tit {
  float: left;
}
.form-box .login-close {
  float: right;
  cursor: pointer;
  width: 22px;
  height: 22px;
  background: url("../../assets/images/drawer/shut_nor_icon.png") no-repeat;
  background-size: 100% 100%;
}
.form-box .login-close:hover {
  background: url("../../assets/images/drawer/shut_hov_pre_icon.png") no-repeat;
  background-size: 100% 100%;
}
.form-box .info-row {
  margin: 11px 0;
  position: relative;
}
.form-box .pwd-row {
  position: relative;
}
.form-box .pwd-row img {
  position: absolute;
  right: 10px;
  top: 18px;
  cursor: pointer;
}
.form-box .input-text {
  font-size: 14px;
  padding-left: 20px;
  box-sizing: border-box;
  width: 100%;
  height: 50px;
  border-radius: 5px;
  border: 0;
  border: 1px solid #c3c3c3;
  outline: 0;
  box-shadow: 0 0 0px 1000px white inset;
}
.form-box .input-code {
  width: 234px;
}
.form-box .input-codebtn {
  padding: 0;
  width: 120px;
  background: #fff;
  float: right;
  text-align: center;
  cursor: pointer;
}
.form-box .submit-row a {
  display: block;
  width: 100%;
  height: 50px;
  line-height: 50px;
  border-radius: 5px;
  text-align: center;
  background: #b11828;
  border: 0;
  font-size: 16px;
  color: #fff;
  margin: 11px 0;
  cursor: pointer;
}

.form-box .submit-row a:hover {
  background: #9c0f1f;
}
.form-box .forgetpwd-row {
  height: 32px;
  font-size: 14px;
}
.form-box .forgetpwd-row span {
  line-height: 32px;
}
.form-box .forgetpwd-row span:first-child {
  float: left;
}
.form-box .forgetpwd-row .auto-login {
  float: left;
  margin-top: 10px;
}
.form-box .forgetpwd-row span:last-child {
  float: right;
}
.form-box .no-userID {
  text-align: center;
  font-size: 14px;
  color: #747474;
  letter-spacing: 1px;
  margin-bottom: 20px;
}
.form-box .no-userID a {
  color: #747474;
}
.form-box .no-userID a:hover {
  color: #b11828;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-active {
  /*transition: 1s;*/
  opacity: 0;
}
.form-box .tips {
  font-size: 14px;
  color: #b11828;
  padding-left: 20px;
}
.form-box .tipsTop {
  padding-right: 20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// Login.vue?c70682c2